import { GraphQlBody } from "../models/common";

export const API = {
    get: async(accessToken: string, path: string, query?: string[]) => {
        const response =  await fetch(`${process.env.REACT_APP_API_BASE}${path}${query && query.length ? '?'+query.join('&') : ''}`, {
            method: 'GET',
            headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
            },
        })
        return response;
    },
    post: async(accessToken: string, path: string, body: any) => {
        const response =  await fetch(`${process.env.REACT_APP_API_BASE}${path}`, {
            method: 'POST',
            headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
        return response;
    }
};

export const API_GQ = {
    post: async(accessToken: string, body: GraphQlBody) => {
        const response =  await fetch(`${process.env.REACT_APP_GRAPHQL_API}`, {
            method: 'POST',
            headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
        return response;
    }
};

export const error = {
    AUTH: 401,
    FORBIDDEN: 403,
    DEFAULT: 500,
    TIME_OUT: 504
};